import React, { useEffect, useMemo } from "react";
import { useMe, useBootstrap } from "@/lib/useMe";
import { resolveAccent, DEFAULT_COLOR } from "@/lib/teamColors";

/**
 * Reads the current user's favourite team (if any) and paints two CSS custom
 * properties on the root element:
 *   --team-primary   (hex)
 *   --team-rgb       ("R,G,B")
 *
 * The rest of the app pulls these vars through index.css. Neutral Fan keeps the
 * default green; no team selected falls back to the app's existing gold accent.
 */
export default function ThemeProvider({ children }) {
  const { data: me } = useMe();
  const { data: boot } = useBootstrap();
  const favId = me?.user?.favorite_team_id;
  const teams = boot?.teams;

  const accent = useMemo(() => resolveAccent(favId, teams), [favId, teams]);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--team-primary", accent.primary || DEFAULT_COLOR.primary);
    root.style.setProperty("--team-rgb", accent.rgb || DEFAULT_COLOR.rgb);
    root.setAttribute("data-team", accent.teamShort || "none");
    return () => {
      // Do not clear on unmount — the accent should persist across navigations.
    };
  }, [accent]);

  return children;
}
